import React, { useState, useEffect } from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import SearchInput from 'components/SearchInput'
import styled from 'styled-components'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ScrollBar, EmptyText } from 'components/CommonStyles'
import { Skeleton } from 'antd'

const Wrapper = styled.div`
  padding: 1rem 0.5rem;
`

const NoDataWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28vh;
  color: #999;
  font-size: 14px;
`
const SkillFilter = ({
  setSkill,
  value,
  citiesList,
  getCities,
  setLocation,
  setFlag,
  flag,
}) => {
  const [citiesData, setCitiesData] = useState([])
  const [pageNum, setPageNum] = useState(1)
  const [search, setSearch] = useState('')
  const [debounced, setDebounced] = useState(() => search)

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(search)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [search])

  React.useEffect(() => {
    if (search) {
      setCitiesData([])
      getCities(`currentPage=0&search=${search}`)
    }
    setPageNum(1)
  }, [debounced])

  useEffect(() => {
    if (citiesList?.length) {
      let list = citiesList
        ?.map(val => {
          return {
            label: val?.name,
            value: val?.name,
          }
        })
        .filter(option => option?.label)

      let newList = [...citiesData, ...list]
      setCitiesData(newList)
      setPageNum(prev => prev + 1)
    }
  }, [citiesList])

  const onChange = checkedvalue => {
    let locationVal = [...value]
    if (checkedvalue.length) {
      setLocation([...value, ...checkedvalue])
    } else {
      let commonData = citiesData.filter(({ value }) =>
        locationVal.includes(value)
      )
      let i = locationVal.findIndex(val => commonData[0].value == val)
      locationVal.splice(i, 1)
      setLocation(locationVal)
    }
  }
  const loadMore = () => {
    if (search) {
      getCities(`currentPage=${pageNum}&search=${search}`)
    } else {
      getCities(`currentPage=${pageNum}`)
    }
  }
  const locationSearch = value => {
    setSearch(value)
    setPageNum(1)
    setCitiesData([])
    if (value?.length) {
      getCities(value, pageNum)
    } else {
      getCities('', pageNum)
    }
  }

  return (
    <Wrapper>
      <SearchInput
        width={'90%'}
        placeholder="Search by keyword"
        bordered={true}
        setSearchValue={value => {
          locationSearch(value)
        }}
        searchValue={search}
        setFlag={setFlag}
        flag={flag}
      />

      <ScrollBar id="scrollableDiv" height={'28vh'}>
        {citiesData?.length > 0 ? (
          <InfiniteScroll
            dataLength={citiesData?.length}
            next={loadMore}
            hasMore={citiesList?.totalPages > pageNum}
            loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
            scrollableTarget="scrollableDiv"
          >
            <FilterCheckBoxComp
              options={citiesData}
              value={value}
              onChange={onChange}
            />
          </InfiniteScroll>
        ) : (
          <NoDataWrapper>No Data found</NoDataWrapper>
        )}
      </ScrollBar>
    </Wrapper>
  )
}

export default SkillFilter
